import { getBSRSToken } from 'Lib'

export function getIsLoggedIn(state) {
    let { bsrsToken, role } = getBSRSToken()
    return bsrsToken && (role === "admin" || role === 'superadmin')
}

export function getIsLoggedInO365(state) {
    return !!state.auth.token.access_token
}

export function getUserInfo(state) {
    return state.auth.user
}

export function getUserEmail(state) {
    return state.auth.user.email
}

export function getChangeSendMailResetPassword(state){
    return state.sendMailResetPassword
}


// WEBPACK FOOTER //
// ./src/features/auth/selectors.js